import { TicketListItemModel } from "@jugl-web/rest-api/tickets/models/TicketListItem";
import { useCallback, useMemo } from "react";
import { UseTicketListOptions } from "./types";

const ticketListCache = new Map<string, TicketListItemModel[]>();

type UseTicketListCacheOptions = {
  [K in keyof UseTicketListOptions]: string;
};

export const useTicketListCache = ({
  entityId,
  filter,
  meId,
  contactId,
  searchQuery,
  sort,
  pageSize,
}: UseTicketListCacheOptions) => {
  const cacheKey = useMemo(
    () =>
      [entityId, filter, meId, contactId, searchQuery, sort, pageSize].join(
        "|"
      ),
    [entityId, filter, meId, contactId, searchQuery, sort, pageSize]
  );

  const getCachedTickets = useCallback(
    () => ticketListCache.get(cacheKey),
    [cacheKey]
  );

  const setCachedTickets = useCallback(
    (tickets: TicketListItemModel[]) => {
      ticketListCache.set(cacheKey, tickets);
    },
    [cacheKey]
  );

  return { getCachedTickets, setCachedTickets };
};
